import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environment.ts/environment';

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
  phone?: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
  errors?: Array<{
    field: string;
    message: string;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private readonly apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  /**
   * Envoie le formulaire de contact
   * @param contactData - Les données du formulaire de contact
   * @returns Observable<ContactResponse> - La réponse de l'API
   */
  submitContactForm(contactData: ContactFormData): Observable<ContactResponse> {
    return this.http.post<ContactResponse>(
      `${this.apiBaseUrl}/contact`,
      contactData
    );
  }
}

